import { apiSlice } from "../app/api/apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getRecap: builder.query({
      query: (id_season) => ({
        url: `/recap/${id_season}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      providesTags: ['Recap']
    }), 
  })
})


export const { 
  useGetRecapQuery
} = userApiSlice